module.exports = __webpack_public_path__ + "/login_ui/img/kr-63e3a1d2c0318bd68fc37433c494db6f.svg";